module.exports = __webpack_public_path__ + "img/linkedin-logo.b3d449ea.svg";